import { Injectable } from '@angular/core';
import {map, switchMap} from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { queryBuilder } from '@metromarkets/sdk';
import { Observable, of } from 'rxjs';
import { Product, PaginatedResponse } from '~shared/models';
import { API_PRODUCTS_LIST_PROXY_ROUTE, API_PRODUCTS_LIST_ROUTE_V3} from '~app/modules/catalog/constants';
import { NUMBER_100 } from '~shared/constants';
import { SearchHttpService } from '~app/modules/generic/services/search-http.service';
import { ActiveFeaturesConfigcatService } from "~shared/modules/active-features/services";
import { FeatureToggleEnum } from '~shared/constants';
@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  proxyFeatureFlag$ = this.featureFlagService.isFeatureEnabledReadyForCurrentCountry$(FeatureToggleEnum.FF_MACO_SB_PROXY_IN_PRODUCT_CAROUSEL)
  constructor(private searchHttpService: SearchHttpService, private http: HttpClient, private readonly featureFlagService: ActiveFeaturesConfigcatService,) {}

  getSortedProducts(queryParams: { [key: string]: any }): Observable<PaginatedResponse<Product>> {
    if (queryParams) {
      const params = queryBuilder.toParams({
        offset: 0,
        ...(!queryParams.limit && { limit: NUMBER_100 }),
        ...queryParams,
        ...{ useCharacteristics: '1' },
      }) as HttpParams;

      return this.proxyFeatureFlag$.pipe(
        switchMap(isUsingProxy => {
          const endpointUrl = isUsingProxy ? API_PRODUCTS_LIST_PROXY_ROUTE() : API_PRODUCTS_LIST_ROUTE_V3();

          return this.searchHttpService.getPaginatedProducts(endpointUrl, params, isUsingProxy ? null : 'angular_storyblok_service');
        }),
        map(({ items, totalCount }: PaginatedResponse<Product>) => ({
          items: items.map(Product.map),
          totalCount,
        }))
      );
    } else {
      return of({ items: [], totalCount: 0 });
    }
  }

  getProductsByEndpoint(endpoint: string): Observable<PaginatedResponse<Product>> {
    return this.http.get<PaginatedResponse<Product>>(endpoint).pipe(
      map((svcResponse: PaginatedResponse<Product>) => ({
        items: svcResponse.items.map((product) => Product.map(product)),
        totalCount: svcResponse.totalCount,
      }))
    );
  }
}
